export default __webpack_public_path__ + "static/media/ennemi.a112ed61.jpg";